import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import IntroPage from "@/pages/IntroPage";
import DiagnosticPage from "@/pages/DiagnosticPage";
import BilanPage from "@/pages/BilanPage";
import AdminSettingsPage from "@/pages/AdminSettingsPage";
import PrivacyPage from "@/pages/PrivacyPage";
import UnsubscribePage from "@/pages/UnsubscribePage";
import LegalPage from "@/pages/LegalPage";
import MerciPage from "@/pages/MerciPage";
import StatusPage from "@/pages/StatusPage";
import FitPage from "@/pages/FitPage";
import { AntiBotChallenge } from "@/components/AntiBotChallenge";
import { MaintenanceGate } from "@/components/MaintenanceGate";

/*
 * Conservation nulle (Phase 2) : le bilan n'est accessible par aucun lien ni
 * jeton. La page /bilan est calculée localement depuis la session active.
 * Les anciennes routes /resultat/:token et /identification sont supprimées.
 */
function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <MaintenanceGate>
          <Routes>
            <Route path="/" element={<IntroPage />} />
            <Route path="/diagnostic" element={<DiagnosticPage />} />
            <Route path="/bilan" element={<BilanPage />} />
            <Route path="/admin/parametres" element={<AdminSettingsPage />} />
            <Route path="/confidentialite" element={<PrivacyPage />} />
            <Route path="/desinscription" element={<UnsubscribePage />} />
            <Route path="/mentions" element={<LegalPage />} />
            <Route path="/merci" element={<MerciPage />} />
            <Route path="/statut" element={<StatusPage />} />
            <Route path="/fit" element={<FitPage />} />

          </Routes>
        </MaintenanceGate>
      </BrowserRouter>
      <AntiBotChallenge />
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
